import React, { FunctionComponent, MouseEvent, useEffect } from "react";

import { FocusableItemWrapper, useKeyboardNavigationContext } from "@multiweb/accessibility";
import { bemClassNames } from "@multiweb/reactUtils";
import { FlagColor, MouseButton } from "@multiweb/types/react";
import { ButtonProvider } from "../ButtonProvider";
import { FlagCircle } from "../FlagCircle";

export type FlagCircleWithTitleProps = {
    /** Název barvy flagu typu FlagColor */
    color: FlagColor;
    /** Popis barvy */
    title?: string;
    /** Příznak značící, jestli je daný flag vybrán */
    isSelected?: boolean;
    /** Zda-li má být prvek při prvním zobrazení zaměřen */
    isInitFocused?: boolean;
    /** Callback volaný při změně */
    onChange?: (color: FlagColor, checked: boolean) => void;
};

const classNames = bemClassNames("flag-circle-with-title-component");

/** Klikatelný flag - barevné kolečko s názvem */
export const FlagCircleWithTitle: FunctionComponent<FlagCircleWithTitleProps> = ({ color, title, isSelected, isInitFocused, onChange }) => {
    const { getNavigationData, focusItem } = useKeyboardNavigationContext();
    const { isFocused, tabIndex } = getNavigationData(color);

    // Podmíněný useEffect pro prvotní zaměření komponenty
    useEffect(() => {
        if (isInitFocused) {
            focusItem(color);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onClick = (event: MouseEvent) => {
        if (event.button === MouseButton.leftButton && onChange) {
            onChange(color, !isSelected);
        }
    };

    return (
        <FocusableItemWrapper id={color} focusable={!!onChange}>
            <ButtonProvider {...{ isFocused, tabIndex, onClick }} width="100%">
                <div className={classNames()}>
                    <FlagCircle key={color} {...{ color, title, isSelected }} />
                    <span className={classNames("title")}>{title}</span>
                </div>
            </ButtonProvider>
        </FocusableItemWrapper>
    );
};
